const underscoreToHyphen = (value: string): string => value.replace(/_/g, "-");

const objectMap = <T extends Record<string, unknown>, U>(
  object: T,
  mapFn: ([key, value]: [string, unknown]) => [string, U],
): Record<string, U> => Object.fromEntries(Object.entries(object).map(mapFn));

const dataPropsFromDataObject = (
  data: Record<string, string>,
): Record<string, unknown> =>
  objectMap(data, entry => [`data-${underscoreToHyphen(entry[0])}`, entry[1]]);

interface BuyButtonProps {
  buyButtonData: {
    insights_event_action?: string;
    insights_event_category?: string;
    insights_event_label?: string;
    insights_event_tealium_event?: string;
    track: string;
  };
  buttonLabel?: string;
}

export const BuyButton = ({
  buyButtonData = { track: "test" },
  buttonLabel = "Buy",
}: BuyButtonProps) => {
  const dataAttributes = dataPropsFromDataObject(buyButtonData);
  return (
    <>
      <button
        type="submit"
        className="btn-primary mobius-quote-details-form__buy_button buy-button js-buy-button portable-hide qa-buy-quote-option"
        {...dataAttributes}
      >
        <span>{buttonLabel}</span>
      </button>
      <button
        type="submit"
        className="btn-primary mobius-quote-details-form__buy_button buy-button js-buy-button portable-show us-buy-button"
        {...dataAttributes}
      >
        <span>{buttonLabel}</span>
      </button>
      <button
        type="submit"
        className="btn-primary mobius-quote-details-form__buy_button buy-button portable-show uk-details-button"
        {...dataAttributes}
      >
        <span>{buttonLabel}</span>
      </button>
    </>
  );
};
